import React from 'react';
import propTypes from 'prop-types';
// import thumbnails from '../../data/thumbnails';

import './NavBox.css';

const NavBox = props => (
  <a className={`NavBox ${props.isLargeBox ? 'large' : 'small'}`} key={props.id} onClick={props.onClick.bind(this, props.navTo)}>
    <section className={'NavBox__progressBarContainer'}>
      <div className={'NavBox__progressBar'} />
    </section>
    { props.thumbnail &&
      <img className={'NavBox__image'} src={props.thumbnail.thumbnail || props.thumbnail.src} alt={props.thumbnail.alt} />
    }
    <section className={'NavBox__itemTextArea'}>
      <h4 className={'NavBox__header'}>
        {props.title}
      </h4>
      <p className={'NavBox__description'}>
        {props.description}
      </p>
    </section>
  </a>
);

export default NavBox;

NavBox.propTypes = {
  thumbnail: propTypes.shape({
    src: propTypes.string.isRequired,
    alt: propTypes.string.isRequired,
  }),
  title: propTypes.string.isRequired,
  description: propTypes.string,
  isLargeBox: propTypes.bool,
  onClick: propTypes.func.isRequired,
  navTo: propTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/NavBox/NavBox.js